import { IFilterCalendarByPlace } from '../../../actions/bookingCalendar/filtering/filterByPlace'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IFilterCalendarByPlace,
): IBookingCalendarStore {
  return {
    ...state,
    filtering: {
      ...state.filtering,
      byPlace: {
        name: action.name,
        persons: action.persons,
      },
    },
  }
}
